import React from 'react';
import {Link} from 'react-router-dom';
import copy from 'clipboard-copy';
import i18n from '../i18n';
import Snackbar from './Snackbar';

class PhotoSetThumbnailView extends React.PureComponent {

    constructor(props) {

        super(props);

        this.handleFullScreenClick = this.handleFullScreenClick.bind(this);
        this.handleShareClick = this.handleShareClick.bind(this);

        
    }

    handleFullScreenClick() {

        if (this.props.onFullScreen)
            this.props.onFullScreen();
    }

    async handleShareClick() {

        await copy(window.location.href);
        Snackbar.show({message: i18n.t('photoSetView.copied')});
    }



    render() {
        const coords = [this.props.photoSet.latitude, this.props.photoSet.longitude];

        return (

            <div className={`photo-thumbnail-view ${this.props.className || ''}`}>

                <img src={this.props.photoSet.thumbnail} alt="thumbnail" className="img-thumbnail"/>

                {this.props.showControls && (

                    <div className="photo-thumbnail-controls btn-toolbar">
                        <div className="btn-group">
                            { this.props.isPhotoLocationNearUserLocation(coords) && 
                                <Link className="btn btn-dark" to={`/camera?photoSet=${this.props.photoSet.id}`}><i className="fas fa-camera"/></Link>
                            }
                            <button type="button" className="btn btn-dark" onClick={this.handleShareClick}><i className="fas fa-share-alt"/></button>
                            <button type="button" className="btn btn-dark" onClick={this.handleFullScreenClick}><i className="fas fa-search-plus"/></button>
                        </div>
                    </div>
                )}

            </div>
        );
    }
}

export default PhotoSetThumbnailView;



// WEBPACK FOOTER //
// ./src/components/PhotoSetThumbnailView.js